import * as React from "react";
const SvgBatteryHorizontal100Percent20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 4h18v3h2v6h-2v3H0V4Zm2 2v8h14V6H2Zm1 1h12v6H3V7Z",
      clipRule: "evenodd"
    })
  );
export default SvgBatteryHorizontal100Percent20Px;
